import { Box, Link, Typography } from "@mui/material";
import { useGetManyReference } from "react-admin";
import { Student } from "../../../providers/studentsProvider";
import { cardTitleStyle, overviewCardStyle } from "../../../misc/backofficeTheme";
import { useDialog } from "../../../hooks/useDialog";
import { ActivitiesTimeline } from "../ActivitiesTimeline";
import { AllActivitiesDialog } from "../../../dialogs/AllActivitesDialog";

export function LatestActivitiesCard({
  student,
  filter,
}: {
  student: Student;
  filter?: { bookedTrainingIds: string[] };
}) {
  const { data } = useGetManyReference("studentActivities", {
    target: "studentUid",
    id: student.id,
    pagination: { page: 1, perPage: 5 },
    sort: { field: "dateTime", order: "DESC" },
  });
  const { dialogProps, openDialog } = useDialog();

  return (
    <>
      <Box
        sx={{
          ...overviewCardStyle,
          maxHeight: 410,
          padding: "25px 30px",
          position: "relative",
        }}
      >
        <Typography sx={cardTitleStyle}>Neueste Aktivitäten</Typography>
        <ActivitiesTimeline student={student} filter={filter} />
        {data && data.length > 0 && (
          <Link onClick={openDialog} variant="body2">
            Alle Aktivitäten
          </Link>
        )}
      </Box>
      <AllActivitiesDialog student={student} filter={filter} {...dialogProps} />
    </>
  );
}
